import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-About-us',
    templateUrl: './About-us.component.html',
    styleUrls: ['./About-us.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutUsComponent implements OnInit {
  status=false;
  constructor() { }

  ngOnInit() {
  }

}
